import {
  Component,
  OnInit,
  Input,
  OnDestroy,
  HostListener,
} from '@angular/core';
import { SubmitButtonShared } from 'src/app/presentation/general/shared/submit-button-shared';
import { Subscription } from 'rxjs';
import { RegisterShared } from 'src/app/presentation/general/shared/register-shared';
import { TextHelper } from 'src/app/utils/text-helper';

@Component({
  selector: 'app-height',
  templateUrl: './height.component.html',
  styleUrls: ['./height.component.scss'],
})
export class HeightComponent implements OnInit, OnDestroy {
  @Input() pageNumber: number;
  @Input() currentPageNumber: number;
  @Input() Redesign:boolean =false
  // height: string;
  hasError = false;
  default = 183;
  heights: number[] = [];
  currentHeight: number;
  subscription: Subscription;
  heightOfset: number;
  constructor(
    private submitButtonShared: SubmitButtonShared,
    private registerShared: RegisterShared,
    private textHelper: TextHelper
  ) {
    this.setDefaultDate();
    this.subscription = this.submitButtonShared.nextButtonClickObs$.subscribe(
      (clicked) => {
        if (clicked && this.pageNumber === this.currentPageNumber) {
          this.registerShared.height = this.heights[this.currentHeight];
          this.registerShared.nextPage();
          // console.log('height', this.registerShared.height)
        }
      }
    );
    this.submitButtonShared.activateNextButton(true);
    this.registerShared.registerActivateButton(4);
  }

  ngOnInit() {}

  @HostListener('window:beforeunload')
  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }
  selectItems(itemIndex: number, itemId: string) {
    const offset = (itemIndex - 2) * -40;

    if (itemId == 'height') {
      this.heightOfset = offset;
      document.getElementById('height').style.top = this.heightOfset + 'px';
    }
  }
  setDefaultDate() {
    this.heights = Array.from({ length: 151 }, (v, i) => {
      return 100 + i;
    });

    this.currentHeight = this.heights.findIndex(
      (index) => this.default == index
    );

    setTimeout(() => {
      this.selectItems(this.currentHeight, 'height');
    }, 1000);
  }
  swipe(swipe: string, item: string, event) {
    if (swipe == 'swipeup') {
      this.nextSlide(item, event.velocity);
    } else if (swipe == 'swipedown') {
      this.perviousSlide(item, event.velocity);
    }
  }
  nextSlide(item: string, velocity: number) {
    velocity = Math.ceil((velocity < 0 ? -1 * velocity : velocity) * 2);
    if (item == 'height') {
      if (
        this.currentHeight >= 0 &&
        this.currentHeight <= this.heights.length
      ) {
        if (this.currentHeight + velocity >= this.heights.length) {
          this.currentHeight = this.heights.length - 1;
          this.selectItems(this.currentHeight, 'height');
        } else {
          this.currentHeight = this.currentHeight + velocity;
          this.selectItems(this.currentHeight, 'height');
        }
      }
    }
  }
  perviousSlide(item: string, velocity: number) {
    velocity = Math.ceil((velocity < 0 ? -1 * velocity : velocity) * 2);
    if (item == 'height') {
      if (this.currentHeight > 0 && this.currentHeight <= this.heights.length) {
        if (this.currentHeight - velocity <= 0) {
          this.currentHeight = 0;
          this.selectItems(this.currentHeight, 'height');
        } else {
          this.currentHeight = this.currentHeight - velocity;
          this.selectItems(this.currentHeight, 'height');
        }
      }
    }
  }
  // checkActivatingButton() {
  //   this.hasError = false;
  //   let activateButton = true;
  //   if (
  //     this.height === '' ||
  //     this.height == undefined ||
  //     this.height.length < 3
  //   ) {
  //     activateButton = false;
  //   }
  //   if (activateButton) {
  //     this.submitButtonShared.activateNextButton(true);
  //     this.registerShared.registerActivateButton(4);
  //   } else {
  //     this.submitButtonShared.activateNextButton(false);
  //     this.registerShared.registerDeactivateButton(4);
  //   }
  // }

  // hasErrors() {
  //   if (parseInt(this.height) < 100 || parseInt(this.height) > 250) {
  //     this.hasError = true;
  //     return true;
  //   }
  //   return false;
  // }
}
